
import {
  schema, normalize
} from 'normalizr';

// Define answer schema
const vendorSchema = new schema.Entity('vendors')
const vendorListSchema = [vendorSchema]

export function adaptVendorsToStore({ data }) {
  const entries = normalize(data.results, vendorListSchema)

  return {
    entries: entries.entities.vendors,
    count: data.count,
    next: data.next,
    previous: data.previous,
    results: data.results
  }
}